// Helper function to get the email carried over
// from the email signup in the footer to
// the newsletter signup
export default function getCarriedOverEmail() {
  if (typeof window === 'undefined') return '';

  try {
    return window.sessionStorage.getItem('emailSignupCarriedOverEmail') || '';
  } catch (e) {
    if (typeof Sentry !== 'undefined') {
      Sentry.captureException(e);
    }
    return '';
  }
}
